import countdown from 'countdown';
const calendary = document.querySelector('.calendary');
const tabsMore = document.querySelector('.more-cetasdi');
const countdownTime = document.querySelector('#countdown');
if (calendary) {
    const calendaryItem = calendary.querySelectorAll('.calendary__li');

    calendaryItem.forEach((item) => {
        const button = item.querySelector('.calendary__h3');
        const response = item.querySelector('.calendary__response');

        button.addEventListener('click', () => {
            // Si el botón clicado ya tiene la clase "open", cerrar el desplegable
            if (button.classList.contains('open')) {
                button.classList.remove('open');
                response.classList.remove('open');
            } else {
            calendaryItem.forEach((otherItem) => {
                const otherButton = otherItem.querySelector('.calendary__h3');
                const otherResponse = otherItem.querySelector('.calendary__response');
                otherButton.classList.remove('open');
                otherResponse.classList.remove('open');
            });
            button.classList.add('open');
            response.classList.add('open');
            }
        });
    });
}
if (tabsMore) {
    const tabsBtns = tabsMore.querySelectorAll('.more-cetasdi__button');
    const tabsRes = tabsMore.querySelectorAll('.more-cetasdi__li');
    tabsRes[0].classList.add('active');
    tabsBtns[0].classList.add('active');
    for (let i = 0; i < tabsBtns.length; i++) {
        tabsBtns[i].addEventListener('click', () => {
            tabsRes.forEach(tab => {
                tab.classList.remove('active');
            });
            tabsBtns.forEach(btn => {
                btn.classList.remove('active');
            });
            tabsBtns[i].classList.add('active');
            tabsRes[i].classList.add('active');
        });

    }
}
if (countdownTime) {
    let timerCountdown = countdownTime.querySelector('.template-3__date');

    if (timerCountdown) {
        let fechaEventoString = timerCountdown.getAttribute('data-date');
        let fechaEventoParts = fechaEventoString.split('/');
        let fechaEvento = fechaEventoParts[0] + '-' + fechaEventoParts[1] + '-' + fechaEventoParts[2];

        // Calcular la diferencia de tiempo entre la fecha actual y la fecha del evento
        let tiempoRestante = countdown(new Date(), new Date(fechaEvento));

        // Función para actualizar el contador
        function updateCountdown(time) {
            // Actualizar los elementos HTML con los nuevos valores
            document.getElementById('days').innerHTML = time.days;
            document.getElementById('hours').innerHTML = time.hours;
            document.getElementById('minutes').innerHTML = time.minutes;
            document.getElementById('seconds').innerHTML = time.seconds;

            // Verificar si la cuenta regresiva ha llegado a cero
            if (time.value <= 0) {
                clearInterval(intervalID); // Limpiar el intervalo
            }
        }

        // Llamar a la función de actualización por primera vez
        updateCountdown(tiempoRestante);

        // Iniciar el intervalo para actualizar el contador cada segundo
        let intervalID = setInterval(function () {
            tiempoRestante = countdown(new Date(), new Date(fechaEvento));
            updateCountdown(tiempoRestante);
        }, 1000);
    }
}

